import React, { useState } from 'react';
import styled from 'styled-components';
import { Title } from './Title'
import { SectionWrapper } from './SectionWrapper';
import SkillSet from './SkillSet'
import SocialIcons from './SocialIcons';
import ReadMore from './ReadMore';

const StyledText = styled.p`
  /* font-family: 'Roboto', sans-serif; */
  font-size: 1.6rem;
  text-align: justify;
  color: #ccc;
  line-height: 1.6;
  p{
    margin-bottom: 0.25em;
  }
`;

const Highlight = styled.span`
  mark{
    color: #eee;
    background-color: rgba(210, 210, 210, 0.01);
    font-weight: bold;
    padding: 0.1rem 0.3rem;
    &:hover{
    font-weight: 600;
    color: var(--color-brand-900);
    background-color: #eee;
    transition: color 0.1s ease-in;
    text-decoration: underline;
  }
  }
`;

const AboutMeSection = ({ handleMailClick }) => {

  const largeHTMLContent = `
        Ever since I was young, I've been fascinated by Engineering stuffs.
        Whether it was tinkering with gadgets, exploring the great outdoors, or immersing myself in creativity,
        I've always had an insatiable curiosity to learn and discover new things.
        Throughout my journey, this innate curiosity has propelled me forward, guiding me towards a career in computer science engineering.
        <br>
        During my graduation, I explored various technologies through courses on platforms like Coursera, where I delved into Python, R, web development, introductory AI, PHP, and more.
        This broad exposure helped me identify my passion, initially sparked by Python, which led me to dive deeper into it.
        <br>
        Later on, I ventured into database management with MySQL and explored Java and Android development.
        Although Android development didn't quite capture my enthusiasm, and my childhood dream of creating websites resurfaced.
        Taking the leap, I began crafting my own portfolio using basic HTML, CSS, and Bootstrap.
        Despite its humble beginnings, this project ignited my passion for web development, prompting me to further gain my skills in this domain.
        <br>
        Post-graduation, I pursued a comprehensive full-stack development course at CDAC, immersing myself in technologies such as Java, Spring Boot, Hibernate, microservices, and React.
        This intensive program equipped me with a robust skill set, leading to my placement at Infinite.
        Professionally, I've had the privilege to work as a software developer.
        Through all these experiences, I've honed my skills in Java, Springboot & React and developed a keen eye for software development.
        <br>
        My journey in computer science engineering has been marked by continuous learning and growth.
        With each project and course, I strive to expand my knowledge base and refine my abilities.
        <br>
        I am passionate about leveraging technology to create innovative solutions and look forward to the ongoing evolution of my skills in this dynamic field.
        `;

  // temp text
  {/* <br>
  During my educational gaps, I seized the opportunity to engage in diverse
          learning experiences and practical endeavors that have significantly enriched my skill set and personal growth.
          Through self-directed learning, online courses, and hands-on projects, I've honed my abilities in
          Reactjs, Redux, Springboot development.
          
        Despite my achievements, I recognized the need to deepen my expertise in React and Spring Boot. 
        Hence, I turned to platforms like Udemy to refine my skills in these areas. */}

  /* Professionally, I've had the privilege to work as a software developer. 
  Through these experiences, I've honed my skills in Java & React and developed a keen eye for Software development.

  But beyond the professional realm, I'm also passionate about photography. 
  Whether it's spending time with my loved ones, indulging in culinary adventures, or capturing moments through photography, 
  I find joy in the simple pleasures of life. */

  /* In my free time, you can often find me [Your Favorite Activities/Hobbies]. 
  I believe in the importance of [Your Beliefs/Values] and strive to [Your Aspirations/Mission]. */

  return (
    <SectionWrapper>
      <Title>About me</Title>
      <StyledText>
        Hello there! I'm <Highlight><mark>Sachin Kumar</mark></Highlight>, a passionate Web/Software Developer. Let me introduce myself...
        <ReadMore htmlContent={largeHTMLContent} maxLength={428} />
        I created this platform as a space to share my thoughts, experiences, and adventures with you.
        So, feel free to explore, connect, and join me on this journey!
      </StyledText>
      <SkillSet />
    </SectionWrapper>
  );
};

export default AboutMeSection;
